const approvalTypes = Object.freeze({
  Pause: 1,
  Reactivate: 4,
  Archive: 2,
  Unarchive: 6,
});

export default approvalTypes;
